export default `---
slug: swift-technical-support
type: work
dateRange: "March 2022 – Dec 2024"
institution: "Swift"
location: "The Netherlands (+ Belgium)"
role: "Technical Customer Support Engineer"
current: false
skills: [Customer Support, Financial Messaging, SWIFT Standards, Technical Communication, ISO 20022]
relatedLinks:
  - label: "RPA Automation Project"
    href: /projects/rpa-automation
  - label: "Salesforce Prompt Builder"
    href: /projects/salesforce-prompt-builder
---

In March 2022, I started working for Swift in the Netherlands as a Technical Customer Support Engineer. Swift is the global provider of secure financial messaging services — essentially the backbone of international bank-to-bank communication. My role involved supporting banks and financial institutions worldwide with technical issues related to Swift's messaging infrastructure and standards.

The job was challenging and intellectually stimulating: every day brought new problems from different institutions, different geographies, different technical setups. It was also my first real exposure to the world of financial services and enterprise software — a very different beast from the academic world. This role was also the launchpad for everything that came next: the RPA automation project started here, the Salesforce Prompt Builder AI project started here, and ultimately my path into Enterprise AI started here.
`;
